module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, [_c('sk-dialog', {
    attrs: {
      "width": "80%",
      "lazy": "",
      "persistent": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.toggleDeleteDialog),
      callback: function($$v) {
        _vm.toggleDeleteDialog = $$v
      },
      expression: "toggleDeleteDialog"
    }
  }, [_c('span', [_vm._v("Are you sure you want to delete this movie?")]), _vm._v(" "), _c('sk-spacer', {
    attrs: {
      "height": 20
    }
  }), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.confirmDelete()
      }
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleDeleteDialog = false
      }
    }
  }, [_vm._v("No")])], 1), _vm._v(" "), (_vm.session && _vm.session.movie) ? _c('div', {
    staticClass: "ticket-component-wrapper"
  }, [_c('div', {
    staticClass: "ticket-component-content"
  }, [_c('sk-title-heading', {
    attrs: {
      "h6": "",
      "label": _vm.session.movie.title
    }
  }, [_c('template', {
    slot: "append"
  }, [(!_vm.activeOrder) ? _c('sk-button', {
    attrs: {
      "link": "",
      "small": "",
      "block": _vm.$breakpoints.sm,
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        _vm.editBasketItem(_vm.session.SessionId)
      }
    }
  }, [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), _c('sk-button', {
    attrs: {
      "link": "",
      "small": "",
      "block": _vm.$breakpoints.sm,
      "loading": _vm.loadingDelete
    },
    nativeOn: {
      "click": function($event) {
        _vm.promtDelete(_vm.order.Session.SessionId)
      }
    }
  }, [_vm._v("Delete")])], 1)], 2), _vm._v(" "), _c('span', {
    staticClass: "label label--invert"
  }, [_vm._v(_vm._s(_vm.order.Session.movie.rating))]), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs6": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "movie-poster"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.session.movie.poster,
      "alt": ""
    }
  })])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "movie-details"
  }, [_c('div', {
    staticClass: "movie-details--content"
  }, [_vm._l((_vm.ticketsGrouped), function(ticketObject, index) {
    return _c('p', {
      key: index
    }, [_vm._v(_vm._s(ticketObject.Quantity) + " x Ticket"), ((ticketObject.Quantity > 1)) ? _c('span', [_vm._v("s")]) : _vm._e()])
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.cinema.name))])], 2), _vm._v(" "), (_vm.session.SessionDate) ? _c('div', {
    staticClass: "movie-details--content"
  }, [_c('p', [_vm._v(_vm._s(_vm.session.SessionDate.additional.string_short_day_of_week) + " " + _vm._s(_vm.session.SessionDate.additional.day) + " " + _vm._s(_vm.session.SessionDate.additional.string_long_month))]), _vm._v(" "), (_vm.session.SessionDate && _vm.session.SessionEndDate) ? _c('span', [_vm._v(_vm._s(_vm.session.SessionDate.additional.no_zero_hour_24) + ":" + _vm._s(_vm.session.SessionDate.additional.minute) + " - " + _vm._s(_vm.session.SessionEndDate.additional.no_zero_hour_24) + ":" + _vm._s(_vm.session.SessionEndDate.additional.minute))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.expandTickets($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.seeBtn))])], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-y-transition"
    }
  }, [(_vm.ticketsGrouped && _vm.expanded) ? _c('div', {
    staticClass: "ticket-component-seats"
  }, [_c('h6', {
    staticClass: "ticket-component-content--heading"
  }, [_vm._v("Your Seats")]), _vm._v(" "), _c('sk-list', _vm._l((_vm.ticketsGrouped), function(ticketObject, TicketType) {
    return _c('sk-list-item', {
      key: TicketType
    }, [_c('sk-ticket-seats', {
      attrs: {
        "ticket-obj": ticketObject,
        "ticket-type": TicketType,
        "seat": "F1"
      }
    })], 1)
  }))], 1) : _vm._e()])], 1)]) : _vm._e(), _vm._v(" "), _c('sk-dialog', {
    staticClass: "video",
    attrs: {
      "width": "50%",
      "persistent": "",
      "lazy": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.showWarning),
      callback: function($$v) {
        _vm.showWarning = $$v
      },
      expression: "showWarning"
    }
  }, [_c('h3', [_vm._v("Please add tickets to your current movie first!")]), _vm._v(" "), _c('p', [_vm._v("you need to add tickets to this movie first before editing the other.")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showWarning = false
      }
    }
  }, [_vm._v("Ok")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77b0ee86","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/performance/performance-info/performance-info.vue
// module id = 963
// module chunks = 0